import React from "react";
import { useInAndOutModel } from "../inAndOutModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useInAndOutModel();
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Statistic Analysis"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Stock-io  List"]}</span>
        {/* <span style={{ color: "#7F7F7F" }}>{"统计分析"} </span>
        <span style={{ color: "#000" }}>/ {"出入汇总表"}</span> */}
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "出入类型",
            placeholder: Locale["Stock-io Type"],
            fieldName: "ioFlag",
            size: "small",
            options: [{ label: Locale["Stock out"], value: 0 }, { label: Locale["Stock in"], value: 1 }]
            // options: [{ label: "出库", value: 1 }, { label: "入库", value: 0 }]
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "单据编号",
            placeholder: Locale["Document No."],
            fieldName: "tradeCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "单据类型",
            placeholder: Locale["Document  Type"],
            fieldName: "tradeTypeCode",
            size: "small",
            // options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE)

        },
        {
            type: SearchTypeEnum.RangePicker,
            // span: 4,
            // // placeholder: "出/入库日期",
            // placeholder: Locale["Stock-io Time"],
            // fieldName: "name",
            // size: "small",
            fieldName:"",
            placeholder: [Locale["Stock-io Time"], Locale["Stock-io Time"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "商品编码",
            placeholder: Locale["Material Code"],
            fieldName: "materialCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "商品名称",
            placeholder: Locale["Material Name"],
            fieldName: "materialName",
            size: "small",
        },
    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}